import { getPostType } from 'utils';

import React from 'react';

import { POST_TYPE } from 'constants/global';

import { PostContainer } from '../TopicCard/styles';
import MeetingBody from './components/MeetingBody';
import PollBody from './components/PollBody';
import TopicBody from './components/TopicBody';
import TopicFooter from './components/TopicFooter';
import TopicHeader from './components/TopicHeader';

interface TopicContentProps {
  post: any;
  refetchPinned: () => void;
  refetchUnpinned: () => void;
}

export const TopicContent: React.FC<TopicContentProps> = ({
  post,
  refetchPinned,
  refetchUnpinned,
}) => {
  const postType = getPostType(post);
  const isPoll = postType === POST_TYPE.POLL;
  const isTopic = postType === POST_TYPE.TOPIC;
  const isMeeting = postType === POST_TYPE.MEET;

  return (
    <PostContainer key={post._id} isMeetingOrPoll={isMeeting}>
      <TopicHeader
        topic={post}
        type={postType}
        refetchPinned={refetchPinned}
        refetchUnpinned={refetchUnpinned}
      />
      {isTopic && (
        <TopicBody
          title={post.title}
          medias={post.media || []}
          content={post.description}
          tags={[]}
        />
      )}

      {isMeeting && (
        <MeetingBody
          title={post.meetingTitle}
          content={post.meetingDescription}
          location={post.location}
          date={post.date}
          time={post.time}
          tags={[]}
        />
      )}

      {isPoll && (
        <PollBody
          title={post.questionTitle}
          content={post.questionDescription}
          pollOptions={post.pollOptions}
          poll={post}
          tags={[]}
          refetchPinned={refetchPinned}
          refetchUnpinned={refetchUnpinned}
        />
      )}

      {!isPoll && <TopicFooter post={post} postType={postType} />}
    </PostContainer>
  );
};
